export default __webpack_public_path__ + "static/media/Boots of the Unholy Communion.d36fabd2.jpg";